
import { Modal } from 'antd'
import { EyeOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { password_reset_link, updatenotificationdata } from '../../../store/Admin/Common/CommonSlice'
import { change_status, get_kam_customers, update_user_kam } from '../../../store/Admin/UserManagement/UserManagementSlice'
import { ButtonSubmit, CustomeButton, TableItem } from '../../../StyledComponents/Common'
import { ActionText, ButtonSection, ContentItem, ContentRow, ContentTitle, ContentValue, DetailContentContainer, HeadSection, TableSection, TopHead } from '../../../StyledComponents/CreateKeyAccountManager'
import AddButton from '../Common/AddButton'
import SimpleTable from '../Common/SimpleTable'
import SubmitButton from '../Common/SubmitButton'

// Own container id: the Profile tab (hidden but still mounted) has its own ToastContainer,
// and in react-toastify v11 containers without an id collide, swallowing these toasts.
const KAM_TOAST_ID = 'kam-action-toast'

function ActionSectionAdmin(props) {
    const dispatch = useDispatch()
    // Selected KAM `_id` (string) while in change mode; "" = nothing selected.
    const [assign_index, setAssignIndex] = useState("")
    const [isEditingKam, setIsEditingKam] = useState(false)
    const [kam_data, setKamData] = useState([])
    const [changeList, setChangeList] = useState(true)
    const [loading, setLoading] = useState(false)
        const [kamdetails, setKamDetails] = useState({})

    const [loading_deactivate, setLoadingDeactivate] = useState(false)
    const [loading_archive, setLoadingArchive] = useState(false)
    const [statusdata, setStatusData] = useState("")
    const [buttonvis, setButtonVis] = useState(false)
    // KAM whose details modal is open; null = closed.
    const [viewKam, setViewKam] = useState(null)
    const [kamCustomers, setKamCustomers] = useState([])
    const [loadingCustomers, setLoadingCustomers] = useState(false)

    // Load the organizations assigned to the KAM whenever its modal opens.
    useEffect(() => {
        if (!viewKam?._id) return
        let cancelled = false
        setKamCustomers([])
        setLoadingCustomers(true)
        dispatch(get_kam_customers(viewKam._id))
            .then(res => {
                if (cancelled) return
                if (res?.payload?.data?.statusCode === 200) {
                    setKamCustomers(res.payload.data.data || [])
                } else {
                    toast.error(res?.payload?.data?.message || "Failed to fetch customers", { containerId: KAM_TOAST_ID })
                }
            })
            .finally(() => { if (!cancelled) setLoadingCustomers(false) })
        return () => { cancelled = true }
    }, [viewKam?._id])

    console.log("props",props.instance.user_details)

    // Initialize kamdetails from instance on mount and whenever instance changes
    useEffect(() => {
        const kam = props?.instance?.kam_user || props?.instance?.kam_details?.[0]
        if (kam?._id) {
            setKamDetails(kam)
        }
    }, [props?.instance?._id])

    // antd Tabs keep hidden panes mounted, so leave KAM change mode whenever the
    // user switches tab or sub-tab and come back to the initial view.
    useEffect(() => {
        if (!props.isActive || props.currentSubTab != 1) {
            setIsEditingKam(false)
            setAssignIndex("")
        }
    }, [props.isActive, props.currentSubTab])

    useEffect(()=>{
        if(changeList === true){
            // let data = props.kam_list.filter((i)=> i._id !== props?.instance?.key_account_manager)
            setKamData(props.kam_list)
            setChangeList(false)
        }

    },[changeList])

    const handleChangeStatus = (status)=> {
        if(status === 'deactivate' || status === 'activate'){
            setLoadingDeactivate(true)
        }else if (status === 'archive'){
            setLoadingArchive(true)
        }
        let user_id = props?.instance?._id
        console.log(user_id);
        const values = {
            status: status,
            org_id:user_id
        }
        dispatch(change_status(values))
        .then(res=>{
            if(res?.payload?.data?.statusCode === 200 ){
                console.log(res.payload?.data.data);
                setStatusData(res.payload?.data.data.status)
                dispatch(updatenotificationdata(res?.payload?.data))
                setLoadingDeactivate(false)
                setLoadingArchive(false)
                if (status === 'archive'){
                    props.setPageType("table")
                }
                else {
                //     let deactivate_user = 0
                //     if(status === 'deactivate'){
                //         deactivate_user = 1
                //     }
                //     props.instance.user_details[0].deactivate_user = deactivate_user
                    props.setInstance(props.instance)
                }
                
            }
        })
        .catch(err=>{
            console.error(err);
        })
    }

    const currentKamId = (kamdetails?._id
        || props?.instance?.kam_user?._id
        || props?.instance?.key_account_manager
        || props?.instance?.kam_details?.[0]?._id)?.toString();

    const selectedKam = kam_data.find((k) => k?._id?.toString() === assign_index)

    const enterEditMode = () => {
        setIsEditingKam(true)
        toast.info("Select a new Key Account Manager and click Update KAM", { containerId: KAM_TOAST_ID })
    }

    const exitEditMode = () => {
        setIsEditingKam(false)
        setAssignIndex("")
    }

    const updateKam = () => {
        const user_id = props?.instance?._id
        const kam = selectedKam
        if (!user_id || !kam?._id) return
        setLoading(true)
        dispatch(update_user_kam({ org_id: user_id, kam_id: kam._id }))
            .then(res => {
                const ok = res?.payload?.status === 200 || res?.payload?.data?.statusCode === 200
                dispatch(updatenotificationdata(res?.payload?.data))
                if (!ok) {
                    toast.error(res?.payload?.data?.message || "Failed to update Key Account Manager", { containerId: KAM_TOAST_ID })
                    return
                }
                toast.success(res?.payload?.data?.message || `Key Account Manager updated to ${kam.full_name}`, { containerId: KAM_TOAST_ID })
                setKamDetails(res?.payload?.data?.kam_details?._id ? res.payload.data.kam_details : kam)
                const updated = {
                    ...props.instance,
                    kam_user: { ...(props.instance?.kam_user || {}), _id: kam._id, full_name: kam.full_name },
                    key_account_manager: kam._id,
                }
                props.setInstance(updated)
                setChangeList(true)
                exitEditMode()
            })
            .catch(err => {
                console.error(err)
                toast.error("Failed to update Key Account Manager", { containerId: KAM_TOAST_ID })
            })
            .finally(() => setLoading(false))
    }

    const handleUpdateKam = () => {
        if (!selectedKam) return
        Modal.confirm({
            title: 'Update Key Account Manager',
            content: `Change Key Account Manager to ${selectedKam.full_name}?`,
            okText: 'Update KAM',
            cancelText: 'Cancel',
            okButtonProps: { style: { backgroundColor: '#FCB614', borderColor: '#FCB614', color: '#FFFFFF', fontWeight: 700 } },
            onOk: updateKam,
        })
    }

    const columns = [
        {
            title: 'S.NO',
            dataIndex: 'sno',
            align: 'left',
            width: 70,
            render: (text, record, index) => <ActionText className='name' style={{ paddingLeft: 0 }}>{index + 1}</ActionText>,
        },
        {
            title: 'KEY ACCOUNT MANAGERS',
            dataIndex: 'full_name',
            align: 'left',
            render: (text, record) => (
                <div className='flex w-full justify-start'>
                    <ActionText className='name' style={{ paddingLeft: 0 }}>{text}</ActionText>
                </div>
              ),
        },
        {
            title: 'ACTION',
            dataIndex: 'action',
            align: 'right',
            render: (text, record) => {
                const id = record?._id?.toString()
                // Fixed width so Assigned / Assign / Selected / Unassigned all line up at the same size.
                const btnBase = 'w-28 h-8 inline-flex items-center justify-center rounded-md text-sm font-semibold'
                let action = null
                if (id === currentKamId) {
                    action = <button disabled className={`${btnBase} bg-[#FCB614] text-white cursor-default`}>Assigned</button>
                } else if (isEditingKam) {
                    // Assign buttons only exist in change mode; lighter tint of the brand amber.
                    action = id === assign_index
                        ? <button type='button' onClick={() => setAssignIndex("")} className={`${btnBase} bg-[#FDE3A0] text-[#7A5200] ring-2 ring-[#FCB614]`}>Selected</button>
                        : <button type='button' onClick={() => setAssignIndex(id)} className={`${btnBase} bg-[#FEF0CC] hover:bg-[#FDE3A0] text-[#7A5200]`}>Assign</button>
                } else {
                    action = <button disabled className={`${btnBase} bg-gray-300 text-gray-600 cursor-not-allowed`}>Unassigned</button>
                }
                return <div className='flex w-full justify-end'>{action}</div>
            },
        },
        {
            title: 'VIEW CUSTOMERS',
            dataIndex: 'view_customers',
            align: 'center',
            render: (text, record) => (
                <button type='button' title='View Customers' onClick={() => setViewKam(record)} className='text-gray-500 hover:text-yellow-500 text-lg leading-none'>
                    <EyeOutlined />
                </button>
            ),
        }
      ];
    const customerColumns = [
        {
            title: <span className='whitespace-nowrap'>S.NO</span>,
            dataIndex: 'sno',
            align: 'center',
            width: 90,
            render: (text, record, index) => index + 1,
        },
        {
            title: <span className='whitespace-nowrap'>ORGANIZATION NAME</span>,
            dataIndex: 'org_name',
            align: 'center',
            render: (text) => text || '—',
        },
        {
            title: <span className='whitespace-nowrap'>USERS</span>,
            dataIndex: 'users',
            align: 'center',
            render: (users) => users?.length
                ? users.map((u) => <div key={u._id}>{u.full_name || '—'}</div>)
                : '—',
        },
        {
            title: <span className='whitespace-nowrap'>UPDATED ON</span>,
            dataIndex: 'kam_updated_at',
            align: 'center',
            width: 220,
            className: 'whitespace-nowrap',
            // Orgs assigned before KAM dates were tracked have no date yet.
            render: (text) => text ? dayjs(text).format('DD MMM YYYY, h:mm A') : '—',
        },
    ];
    console.log(props.instance,kamdetails,"props.instance");
  return (
    <>
        <DetailContentContainer style={props.currentSubTab == 1 ? { maxWidth: 760 } : undefined}>
            {props.currentSubTab == 1 ? 
                <>
                    {/* Right padding matches the table cell padding so the buttons line up with the ACTION column. */}
                    <HeadSection style={{ justifyContent: 'space-between', paddingRight: 16 }}>
                        <TopHead>
                            <ContentItem style={{ flex: 'none' }}>CURRENT KAM</ContentItem>
                            <ContentItem className='values' style={{ flex: 'none' }}>{kamdetails?.full_name || props?.instance?.kam_user?.full_name || props?.instance?.kam_details?.[0]?.full_name || 'Unassigned'}</ContentItem>
                        </TopHead>
                        {!isEditingKam ? (
                            <SubmitButton type='button' title="Change KAM" handleClick={enterEditMode} is_icon={false} />
                        ) : (
                            <div className='flex items-center'>
                                <button
                                    type='button'
                                    className='px-4 py-2 rounded-md text-sm font-semibold border border-gray-300 text-gray-600 hover:bg-gray-100'
                                    onClick={exitEditMode}
                                    disabled={loading}
                                >
                                    Cancel
                                </button>
                                {selectedKam ? (
                                    <SubmitButton type='button' title="Update KAM" handleClick={handleUpdateKam} loading={loading} is_icon={false} ml="12px" />
                                ) : null}
                            </div>
                        )}
                    </HeadSection>
                    <TableSection>
                        <TableItem
                            rowKey={(record) => record?._id?.toString()}
                            name="kam"
                            columns={columns}
                            dataSource={kam_data}
                            pagination={false}
                        />
                    </TableSection>
                </>
            : 
            <>
                <HeadSection>
                    <ContentItem>Status:<span className='font-bold text-md'>{statusdata==="deactivate"?"Deactive":"Active"}</span></ContentItem>
                    {/* <ContentItem className='values'>{props.instance?.user_details[0]?.deactivate_user == 0 ? "Active" : "Deactive"}</ContentItem> */}
                    {/* {props?.instance?.user_details[0]?.deactivate_user == 0 ? */}
                  {statusdata==="deactivate"?<button className='m-5 bg-yellow-500 p-2 text-white text-md font-semibold hover:bg-black cursor-pointer rounded-md ' onClick={()=> handleChangeStatus("activate")} >Activate</button>:  <button className='m-5 bg-yellow-500 p-2 text-white text-md font-semibold hover:bg-black cursor-pointer rounded-md ' onClick={()=> handleChangeStatus("deactivate")} >Deactivate</button>}
          
                    <button className='m-5 bg-yellow-500 p-2 text-white text-md font-semibold hover:bg-black cursor-pointer rounded-md ' onClick={()=> handleChangeStatus("archive")}>Archive</button>
                     {/* <ButtonSubmit  size='large' onClick={()=> handleChangeStatus("deactivate")} >Deactivate User</ButtonSubmit> : 
                     <ButtonSubmit size='large' onClick={()=> handleChangeStatus("activate")} >Activate User</ButtonSubmit> */}
                    {/* }                     */}
                    {/* <CustomeButton size='large' className='ml-5' onClick={()=> handleChangeStatus("archive")} loading={loading_archive}>Move to Archives</CustomeButton> */}
                    {/* <SubmitButton type='button' title="Deactivate User" is_icon={false} ml="28px" /> */}
                </HeadSection>
            </>
            } 
        </DetailContentContainer>
        <Modal
            open={!!viewKam}
            title={viewKam?.full_name}
            onCancel={() => setViewKam(null)}
            footer={null}
            width={860}
            centered
            destroyOnClose
        >
            {/* Long lists scroll inside this box; a fixed-height table scroll
                would reserve an arrowed scrollbar even for a single row. */}
            <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                <TableItem
                    rowKey={(record) => record?._id?.toString()}
                    columns={customerColumns}
                    dataSource={kamCustomers}
                    loading={loadingCustomers}
                    pagination={false}
                    locale={{ emptyText: 'No organizations assigned to this KAM' }}
                />
            </div>
        </Modal>
        <ToastContainer containerId={KAM_TOAST_ID} position="top-center" autoClose={3000} />
    </>
    
  )
}

export default ActionSectionAdmin